var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BranchRegionReport',{attrs:{"items":_vm.items},on:{"updated":_vm.onUpdate}})
}
var staticRenderFns = []

export { render, staticRenderFns }